import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import OrderAPI from '@/apps/order/classes/api/OrderAPI';
import { useOrdersCreateCalculatorStore, useOrdersCreateDataPreparedStore } from '@/apps/order/stores/ordersCreate';
import DataPreparedParamsInterface from '@/apps/order/interfaces/ordersCreate/DataPreparedParamsInterface';

let alreadyFetched = false;

const hasDataPreparedStepConsumptionPoint = async (): Promise<void> => new Promise<void>(
  (resolve, reject) => {
    nextTick(async () => {
      try {
        const dataPreparedStore = useOrdersCreateDataPreparedStore();
        const { dataConsumptionPoint } = storeToRefs(dataPreparedStore);

        const dataCalculatorPreparedStore = useOrdersCreateCalculatorStore();
        const { formData, selectedTariffs } = storeToRefs(dataCalculatorPreparedStore);

        if (dataConsumptionPoint.value !== undefined) {
          resolve();
          return;
        }

        if (!alreadyFetched) {
          const params: DataPreparedParamsInterface = {};
          if (formData.value.salesPartnerNumber) {
            params.salesPartnerNumber = formData.value.salesPartnerNumber;
          }

          if (formData.value.brand_id) {
            params.brand_id = formData.value.brand_id;
          }

          const firstSelectedTariff = Object.values(selectedTariffs.value)[0] as Record<string, any> | undefined;
          if (firstSelectedTariff?.category?.key) {
            params.product_category = firstSelectedTariff.category.key;
          }

          await OrderAPI.fetchDataPreparedStepConsumptionPoint(params).then((data) => {
            dataConsumptionPoint.value = data;
          });

          alreadyFetched = true;
        }

        if (dataConsumptionPoint.value === undefined) {
          reject(new Error('missing data prepared'));
          return;
        }

        resolve();
      } catch (e) {
        reject(new Error(['fetch data prepared failed', e].join(' ')));
      }
    });
  },
);

export default hasDataPreparedStepConsumptionPoint;
